import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=0c260893&scoped=true&"
import script from "./SubTitle.vue?vue&type=script&lang=ts&"
export * from "./SubTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=0c260893&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c260893",
  null
  
)

export default component.exports